module.exports = __webpack_public_path__ + "static/headerIcon-a50044c9942988ba460641934063236a.svg";